'use client'
import { useEffect, useState } from 'react';
import Image from 'next/image';
import cl from 'clsx';
import logo from '@/public/images/logo.svg';
import SelectLanguage from '@/ui/select-language';
import useAuthStore from '@/store/auth';
import Link from 'next/link';
import styles from './styles.module.css';
import Navigation from "@/components/navigation";
import {useDictStore} from "@/store/useDictStore";
import BurgerMenu from "@/components/burger-menu";
import AccountModal from "@/components/account-modal";
import SignUp from "@/components/sign-up";
import LogIn from "@/components/log-in";

export default function Header({ dict }) {
    const { isAuth, hydrate } = useAuthStore();
    const [hydrated, setHydrated] = useState(false);
    const setDict = useDictStore((state) => state.setDict);

    useEffect(() => {
        setDict(dict);
    }, [dict, setDict]);

    useEffect(() => {
        hydrate();
        setHydrated(true);
    }, [hydrate]);

    return (
        <section id="header" className={cl(styles.header__wrapper, 'header')} data-name="header">
            <div className={cl(styles.header, 'container')}>
                <Link href={"/"}>
                    <Image className={styles.header__logo} src={logo} alt='logo' />
                </Link>
                {hydrated && !isAuth && (
                    <>
                        <SignUp dict={dict} showButton={false} />
                        <LogIn dict={dict} showButton={false} />
                    </>
                )}
                {hydrated && <Navigation dict={dict} />}
                <div className={styles.header__buttons}>
                    {hydrated && (
                        <>
                            {isAuth ? (
                                <AccountModal dict={dict} />
                            ) : (
                                <>
                                    <SignUp dict={dict} renderModal={false} />
                                    <LogIn dict={dict} renderModal={false} />
                                </>
                            )}
                        </>
                    )}
                    <SelectLanguage />
                </div>
                <BurgerMenu dict={dict} />
            </div>
        </section>
    );
}
